package com.ervasstudio.tracoemovimento.components.sections

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.sections.mobile.HeaderMobile


@Composable
fun Header(
    expandedItem: Int = 0,
    isMobile: Boolean = false,
) {
    if (isMobile) {
        HeaderMobile(expandedItem)
    } else {
        HeaderDesktop(expandedItem)
    }
}